<template>
    <div class="login-wrap">
        <div class="ms-login">

            <img src="../assets/logo.png" alt="">
            
            <h2>华统--登录</h2>

            <div class="login">

                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">

                    <el-form-item prop="username">
                        <el-input suffix-icon="el-icon-user" v-model="ruleForm.username" placeholder="用户名"></el-input>
                    </el-form-item>

                    <el-form-item prop="password">
                        <el-input suffix-icon="el-icon-lock" type="password" placeholder="密码"
                            v-model="ruleForm.password"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <div class="login-btn">
                            <el-button type="primary" icon="el-icon-user" @click="submitLogin('ruleForm')">确认登录</el-button>
                        </div>
                    </el-form-item>

                    <el-link>华统集团</el-link>

                    <br>

                    <el-link>污水污泥饲料管理审批平台</el-link>

                </el-form>

            </div>

        </div>
    </div>

</template>
<script>
    import { login } from '../router/api';

    export default {
        name: "Login",
        data() {
            return {
                ruleForm: {
                    username: "",
                    password: "",
                },
                rules: {
                    username: [{ required: true, message: "请输入用户名", trigger: "blur" }, { min: 5, max: 14, message: '长度在 5 到 14 个字符', trigger: 'blur' }],
                    password: [{ required: true, message: "请输入密码", trigger: "blur" }, { min: 6, message: '密码长度要大于6', trigger: 'blur' }],
                },
            };
        },
        methods: {
            submitLogin() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        login({
                            tell: this.ruleForm.username,
                            password: this.ruleForm.password,
                        }).then(res => {
                            if (res.code == 1) {
                                this.$message.success('登录成功');
                                setTimeout(() => {
                                    localStorage.setItem('ws_tell',this.ruleForm.username);
                                    localStorage.setItem('ws_pass',this.ruleForm.password);
                                    localStorage.setItem('ws_name',res.data[0].name);
                                        this.$router.push('./flag')
                                }, 1000)
                            } else {
                                this.$message.error('登录失败');
                            }
                        }).catch(err => {
                            console.log(err);
                        });
                    } else {
                        this.$message.error('登录失败');
                        return false;
                    }
                });
            }
        },

        created() {
            let that = this;
            document.onkeydown = function (e) {
                e = window.event || e;
                if (that.$route.path == "/login" && (e.code == "Enter" || e.code == "enter")) {
                    //验证在登录界面和按得键是回车键enter //登录函数
                    that.submitLogin('ruleForm');
                }
            };
        },
    };

</script>
<style scoped>
    .login-wrap {
        background-color: rgb(235, 235, 231);
        width: 100%;
        height: 100vh;
        background-size: 100% 100%;
        background-position: center center;
        overflow: auto;
        position: relative;
    }

    img {width: 180px;
        height: 120px;
        margin-bottom: 20px;
    }

    .ms-login {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 400px;
        height: 500px;
        line-height: 30px;
        transform: translate(-50%, -60%);
        padding: 40px;
        border-radius: 5px;
        background: #fff;
        border: 2px solid #409EFF;

        text-align: center;
    }


    .login-btn {
        text-align: right;
        margin: 15px 0 20px 0;
    }

    .login-btn button {
        width: 120px;
    }
</style>


